
import {
  ANNOUNCEMENT_STATUS,
  ANNOUNCEMENT_TYPE,
} from "../../../services/flitEnum";

export function getAnnouncementStatusCssClasses(status) {
  var type;
  switch (status) {
    case ANNOUNCEMENT_STATUS.DRAFT:
      type = "info"
      break;
    case ANNOUNCEMENT_STATUS.PUBLISHED:
      type = "success"
      break;
    case ANNOUNCEMENT_STATUS.DELETED:
      type = "dark"
      break;
    default: 
      type = ""
  }

  return `label label-lg label-light-${type
    } label-inline`;
}

export function getAnnouncementTypeCssClasses(announcementType) {
  var type;
  switch (announcementType) {
    case ANNOUNCEMENT_TYPE.GENERAL:
      case ANNOUNCEMENT_TYPE.UPDATE:
      type = "primary";
      break;
    case ANNOUNCEMENT_TYPE.FEATURE:
      case ANNOUNCEMENT_TYPE.EVENT:
        case ANNOUNCEMENT_TYPE.FEEDBACK:
      type = "info";
      break;
    case ANNOUNCEMENT_TYPE.BUG_FIX:
      case ANNOUNCEMENT_TYPE.POLICY:
        case ANNOUNCEMENT_TYPE.SUPPORT:
      type = "success";
      break;
    case ANNOUNCEMENT_TYPE.MAINTENANCE:
      case ANNOUNCEMENT_TYPE.PERFORMANCE:
        case ANNOUNCEMENT_TYPE.SECURITY:
      type = "warning";
      break;
    default:
      type = ""
  }

  return `label label-lg label-light-${type
    } label-inline`;
}

